import './App.css';
import React, { useState, Suspense, lazy } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Loader from './components/loader/Loader';
import MoranHero from './screens/FirstScreen';
import MazalTovSection from './screens/SecondScreen';
import AdvantagesSection from './screens/ForthScreen';
import ServicesSection from './components/Services/Services';
import ProcessSection from './components/ProcessNew/Process';
import ProjectsSection from './screens/Projects';
import AboutMe from './components/me/Me';
import FAQSection from './components/FAQ/FAQ';
import Navbar from './components/Navbar/Navbar';
import Footer from './components/Footer/Footer';
import WhatsAppButton from './components/WhatsAppButton/WhatsAppButton';
import Seo from './components/SEO/Seo';

const Privacy = lazy(() => import('./pages/Privacy'));
const Accessibility = lazy(() => import('./pages/Accessibility'));

const HomePage = () => {
  const [loading, setLoading] = useState(true);

  return (
    <>
      <Seo
        title="מורן וינברגר | עיצוב פנים וניהול פרויקטים"
        description="סטודיו לעיצוב פנים וניהול פרויקטים שדואג לשים דגש על תכנון מדויק, תקציב שקוף ולוחות זמנים שנשמרים - מהרעיון ועד המפתח ביד, בלי הפתעות ובלי כאבי ראש."
        path="/"
      />
      {loading && <Loader onComplete={() => setLoading(false)} />}
      <Navbar />
      <MoranHero />
      <MazalTovSection />
      <AdvantagesSection />
      <AboutMe />
      <ServicesSection />
      <ProjectsSection />
      <ProcessSection />
      <FAQSection />
      <Footer />
      <WhatsAppButton />
    </>
  );
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route
          path="/privacy"
          element={
            <>
              <Seo
                title="תקנון ומדיניות פרטיות | מורן הום"
                description="תקנון, תנאי השימוש ומדיניות הפרטיות של אתר מורן הום - מורן וינברגר, עיצוב פנים וניהול פרויקטים."
                path="/privacy"
                noindex
              />
              <Suspense fallback={<div style={{ minHeight: '100vh', background: '#faf9f7' }} />}>
                <Privacy />
              </Suspense>
            </>
          }
        />
        <Route
          path="/accessibility"
          element={
            <>
              <Seo
                title="הצהרת נגישות | מורן הום"
                description="הצהרת הנגישות של אתר מורן הום - מורן וינברגר, עיצוב פנים וניהול פרויקטים. האתר מונגש ברמת AA בהתאם לתקנות ולתקן WCAG 2.2."
                path="/accessibility"
                noindex
              />
              <Suspense fallback={<div style={{ minHeight: '100vh', background: '#faf9f7' }} />}>
                <Accessibility />
              </Suspense>
            </>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
